import PropTypes from 'prop-types';
import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import './modal.scss';

class Modal extends React.Component {
  render() {
    const modalContent = this.props.isOpen ? (
      <div className="modal modal-back">
        {this.props.children}
      </div>
    ) : null;
    return (
      <ReactCSSTransitionGroup
        transitionName={this.props.transitionName}
        transitionEnterTimeout={500}
        transitionLeaveTimeout={300}>
        {modalContent}
      </ReactCSSTransitionGroup>
    );
  }
}

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  transitionName: PropTypes.string.isRequired
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/shared/modal.js